import { onMessageToWebApp } from "./webAppMessenger";
import { QR_CODE_RECOGNIZED } from "./messageTypes";
const vibrateAvailable = navigator && navigator.vibrate;

if (vibrateAvailable) {
  onMessageToWebApp(QR_CODE_RECOGNIZED, () => {
    navigator.vibrate(100);
  });
}
